const cellStates = {
    NONE: 0,
    ACTIVE: 1,
    FORM: 2
}

export {
    cellStates
}